<div class="page-title">Change Password</div>

<div class="panel">

  <div class="panel-body">

    <h2 style="color: red;">You Need to Change Password with Strong Password Otherwise you Cannot Login</h2>

    <div class="row">
      <div class="col-lg-2 label-text-right">
        *Old Password:
      </div>
      <div class="col-lg-4">
        <dx-text-box [(ngModel)]="data.OldPassword"></dx-text-box>
      </div>
    </div>

    <div class="row">

      <div class="col-lg-2 label-text-right">
        *New Password:
      </div>
      <div class="col-lg-4">
        <dx-text-box [(ngModel)]="data.NewPassword" (onValueChanged)="newPasswordChanged()">
        </dx-text-box>
        <div style="color:red;" *ngIf="newPasswordErrorMessage && newPasswordErrorMessage.length > 0">
          {{newPasswordErrorMessage}}</div>
      </div>

    </div>

    <div class="row">
      <div class="col-lg-2 label-text-right">
        *Confirm Password:
      </div>
      <div class="col-lg-4">
        <dx-text-box [(ngModel)]="data.ConfirmPassword" (onValueChanged)="confirmPasswordChanged()">
        </dx-text-box>
        <div style="color:red;" *ngIf="confirmPasswordErrorMessage && confirmPasswordErrorMessage.length > 0">
          {{confirmPasswordErrorMessage}}</div>
      </div>
    </div>




    <div class="col-lg-8 row">
      <div class="alert alert-success" *ngIf="successMessage && successMessage.length > 0">
        {{successMessage}}
      </div>
      <div class="alert alert-danger" *ngIf="errorMessage && errorMessage.length > 0">
        {{errorMessage}}
      </div>

    </div>

    <div class="col-lg-8 row">


      <dx-button width="100%" [disabled]="!canChangePassword" text="Change Password" (click)="resetPassword($event)"
        type="success"></dx-button>

    </div>

  </div>

</div>



<dx-popup class="popup" [width]="450" [height]="'auto'" [showTitle]="true" title="Information" [dragEnabled]="true"
  [closeOnOutsideClick]="true" [(visible)]="isMessageVisible">
  <div *dxTemplate="let data of 'content'">
    <div class="alert alert-success" *ngIf="successMessage.length > 0">
      {{successMessage}}
    </div>
    <div class="alert alert-danger" *ngIf="errorMessage.length > 0">
      {{errorMessage}}
    </div>

    <dx-button class="pull-right" style="margin-bottom: 8px !important;" type="default" text="Close"
      (onClick)="closePopup()"></dx-button>
  </div>
</dx-popup>
